import actions from './actions';
import mutations from './mutations';

function initialState() {
  return {
    searchValue: '',
    displayCards: true,
    displayList: false,
    searchJira: false,
    searchConfluence: false,
    searchPersonal: true,
    searchClosed: false,
    searchOpened: true,
    searchStatus: false,
    statusOptions: [
      { text: 'Alle', value: false },
      { text: 'In Progress', value: '3' },
      { text: 'To Do', value: '10000' },
      { text: 'Backlog', value: '10100' },
      { text: 'Selected for Development', value: '10101' },
      { text: 'Needs info (external)', value: '10200' },
    ],
    sortKey: null,
    sortOrder: null,
  };
}

const filters = {
  state: initialState,
  actions,
  mutations: {
    ...{
      RESET_FILTER(state) {
        const initState = initialState();
        Object.keys(initState).forEach((key) => {
          state[key] = initState[key];
        });
      },
    },
    ...mutations,
  },
};

export default filters;



// WEBPACK FOOTER //
// ./src/store/modules/filters/filters.js